import * as retailType from "../../action/actiontype/RetailType/RetailType";

const retailReducer = (state = {}, action) => {
  switch (action.type) {
    case retailType.RETAIL_REQUEST:
      return {
        ...state,
        retailLoading: true,
        retailResponse: {},
        retailError: null,
      };
    case retailType.RETAIL_REQUEST:
      return {
        ...state,
        retailLoading: false,
        retailResponse: action.payload,
        retailError: null,
      };
    case retailType.RETAIL_FAILURE:
      return {
        ...state,
        retailLoading: false,
        retailResponse: action.payload,
        retailError: {},
      };
    case retailType.RETAIL_PHARMACY_REQUEST:
      return {
        ...state,
        retailPharamacyLoading: true,
        retailPharamacyResponse: {},
        hospitalPharamacyError: null,
      };
    case retailType.RETAIL_PHARMACY_SUCCESS:
      return {
        ...state,
        retailPharamacyLoading: false,
        retailPharamacyResponse: action.payload,
        retailPharamacyError: null,
      };
    case retailType.RETAIL_PHARMACY_FAILURE:
      return {
        ...state,
        retailPharamacyLoading: false,
        retailPharamacyError: action.payload,
        retailPharamacyResponse: {},
      };
    case retailType.RETAIL_REQUEST_GETBYID:
      return {
        ...state,
        retailGetIdLoading: true,
        retailGetIdResponse: {},
        retailGetIdError: null,
      };
    case retailType.RETAIL_SUCCESS_GETBYID:
      return {
        ...state,
        retailGetIdLoading: false,
        retailGetIdResponse: action.payload,
        retailGetIdError: null,
      };
    case retailType.RETAIL_FAILURE_GETBYID:
      return {
        ...state,
        retailGetIdLoading: false,
        retailGetIdResponse: {},
        retailGetIdError: action.payload,
      };
    case retailType.RETAIL_REQUEST_UPDATE:
      return {
        ...state,
        retailUpdateLoading: true,
        retailUpdateResponse: {},
        retailUpdateError: null,
      };
    case retailType.RETAIL_SUCCESS_UPDATE:
      return {
        ...state,
        retailUpdateLoading: false,
        retailUpdateResponse: action.payload,
        retailUpdateError: null,
      };
    case retailType.RETAIL_FAILURE_UPDATE:
      return {
        ...state,
        retailUpdateLoading: false,
        retailUpdateResponse: action.payload,
        retailUpdateError: {},
      };
      case retailType.RETAIL_REQUEST_CREATE:
        return {
            ...state,
            retailCreateLoading: true,
            retailCreateResponse: {},
            retailCreateError: null
        }
    case retailType.RETAIL_SUCCESS_CREATE:
        return {
            ...state,
            retailCreateLoading: false,
            retailCreateResponse: action.payload,
            retailCreateError: null
        }
    case retailType.RETAIL_FAILURE_CREATE:
        return {
            ...state,
            retailCreateLoading: false,
            retailCreateResponse: {},
            retailCreateError: action.payload,
        }
    default:
      return state;
  }
};

export default retailReducer;
